import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TooltipOnHover from '../../../components/TooltipOnHover';
import { NoteIcon } from '../../../components/Icons';
import FirefoxSafeIcon from '../../../components/FirefoxSafeIcon';

var PublicNoteLink =
/*#__PURE__*/
function (_Component) {
  _inherits(PublicNoteLink, _Component);

  function PublicNoteLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PublicNoteLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PublicNoteLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          noteId = _this$props.noteId,
          onClick = _this$props.onClick;
      onClick(event, {
        noteId: noteId
      });
    });

    return _this;
  }

  _createClass(PublicNoteLink, [{
    key: "renderPublicNoteLink",
    value: function renderPublicNoteLink() {
      var _this$props2 = this.props,
          url = _this$props2.url,
          onMouseDown = _this$props2.onMouseDown,
          children = _this$props2.children;
      return React.createElement("a", {
        href: url,
        onClick: this.onClick,
        onMouseDown: onMouseDown,
        className: "font-weight-medium pointer padding-horizontal-smaller entity-highlight"
      }, React.createElement("span", {
        className: "padding-right-smaller margin-left-smallest",
        style: {
          verticalAlign: '1px'
        }
      }, React.createElement(FirefoxSafeIcon, {
        className: "note-link-icon"
      }, React.createElement(NoteIcon, {
        size: 12
      }))), children);
    }
  }, {
    key: "renderPrivateNoteLink",
    value: function renderPrivateNoteLink() {
      var _this$props3 = this.props,
          url = _this$props3.url,
          onMouseDown = _this$props3.onMouseDown,
          children = _this$props3.children;
      return React.createElement(TooltipOnHover, {
        id: "channel-note-order-by",
        tooltipContent: "Sign In \u2013\xA0Accessible to team members only",
        placement: "top"
      }, React.createElement("a", {
        href: url,
        onMouseDown: onMouseDown,
        className: "shade-20 font-weight-medium pointer padding-horizontal-smaller background-shade-50"
      }, React.createElement("span", {
        className: "shade-20 padding-right-smaller margin-left-smallest",
        style: {
          verticalAlign: '1px'
        }
      }, React.createElement(FirefoxSafeIcon, {
        className: "note-link-icon"
      }, React.createElement(NoteIcon, {
        size: 12
      }))), children));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          isNotePublic = _this$props4.isNotePublic,
          attributes = _this$props4.attributes;
      return React.createElement("span", Object.assign({
        className: "position-relative"
      }, attributes), isNotePublic ? this.renderPublicNoteLink() : this.renderPrivateNoteLink());
    }
  }]);

  return PublicNoteLink;
}(Component);

_defineProperty(PublicNoteLink, "propTypes", {
  noteId: PropTypes.string.isRequired,
  isNotePublic: PropTypes.bool,
  url: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func,
  attributes: PropTypes.object,
  children: PropTypes.any
});

export default PublicNoteLink;